import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';

import './style.scss';

const getRecommendedText = (recommendedType, i18n) => {
    switch (recommendedType) {
        case 'recommended':
            return {
                label: i18n.t('gig_page_perseus.packages.recommended'),
                hint: i18n.t('gig_page_perseus.packages.recommended_hint')
            };
        case 'customized':
            return {
                label: i18n.t('gig_page_perseus.packages.customized'),
                hint: i18n.t('gig_page_perseus.packages.customized_hint')
            };
        default:
            return {
                label: '',
                hint: ''
            };
    }
};

const RecommendedBadge = ({recommendedType, hintPos}) => {
    const className = classNames('recommended-badge', hintPos);

    return (
        <I18nProvider>
            {({ i18n }) => {
                const recommendedText = getRecommendedText(recommendedType, i18n);

                return (
                    <b className={className} data-hint={recommendedText.hint}>
                        {recommendedText.label}
                    </b>
                );
            }}
        </I18nProvider>
    );
};

RecommendedBadge.propTypes = {
    recommendedType: PropTypes.string,
    hintPos: PropTypes.string
};

RecommendedBadge.defaultProps = {
    hintPos: 'hint--left'
};

export default RecommendedBadge;
